import { createSlice } from '@reduxjs/toolkit';

import { SlicePayload } from '@/types';
import { ProductModel } from '@/models';

export type WishListState = {
  content: string[];
  pendingProductIdForWishList?: string;
  products: ProductModel[];
}

export const initialState: WishListState = {
  content: [],
  pendingProductIdForWishList: undefined,
  products: [],
};

const wishList = createSlice({
  name: 'wishList',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    getWishList: () => {
    },

    getWishListSuccess: (state, action: SlicePayload<{ products: string[] }>) => {
      state.content = action.payload.products;
    },

    setProductsWishListSuccess: (state, action: SlicePayload<{ products: ProductModel[] }>) => {
      state.products = action.payload.products;
    },

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    addProductToWishList: (state, action: SlicePayload<{ partnumber: string, hydrate?: true }>) => {
      state.content.push(action.payload.partnumber);
      if (action.payload.partnumber === state.pendingProductIdForWishList) {
        delete state.pendingProductIdForWishList;
      }
    },

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    removeProductFromWishList: (_state, _action: SlicePayload<{ partnumber: string }>) => {
    },

    removeProductFromWishListSuccess: (state, action: SlicePayload<{ partnumber: string }>) => {
      state.content = state.content.filter((product) => product !== action.payload.partnumber);
    },

    storePendingProductToWishList: (state, action: SlicePayload<{ partnumber: string }>) => {
      state.pendingProductIdForWishList = action.payload.partnumber;
    }
  }
});

export const {
  getWishList, getWishListSuccess,
  setProductsWishListSuccess,
  addProductToWishList,
  removeProductFromWishList, removeProductFromWishListSuccess,
  storePendingProductToWishList
} = wishList.actions;

export default wishList.reducer;
